module.exports = __webpack_public_path__ + "img/questionCount.d86b3fd7.svg";